<template>
  <q-row
    class="container"
  >
    <div class="contact-content">
      <q-content-loader :content="content" />
    </div>
  </q-row>
</template>

<script>
  import myImage from '../../assets/images/me.jpg';
  import contentLoader from "../../components/contentLoader";

  export default {
    name: "QContact",

    components: {
      'q-content-loader': contentLoader
    },

    data() {
      return {
        content: {},
        myImage: myImage,
        ruleForm: {
          name: '',
          phone: '',
          email: '',
          desc: ''
        },
        rules: {
          name: [
            {required: true, message: 'Please input your name', trigger: 'blur'},
            {min: 3, max: 50, message: 'Length should be 3 to 50', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: 'Please enter your phone', trigger: 'blur'}
          ],
          email: [
            {required: true, message: 'Please input your email address', trigger: 'blur'}
          ],
          desc: [
            {required: true, message: 'Please input', trigger: 'blur'}
          ]
        }
      }
    },

    computed: {
      isRtl() {
        return this.$qt('direction') === 'rtl';
      },
      getImageContainer() {
        let ret = {};
        ret.float = this.isRtl ? 'left' : 'right';

        return ret;
      },
      contactImageStyle() {
        let ret = {};
        ret.width = '300px';
        ret.borderRadius = '5px';

        return ret;
      },
      getFormContainer() {
        let ret = {};
        ret.float = this.isRtl ? 'right' : 'left';
        ret.width = '500px';

        return ret;
      },
      getSocialContainerStyle() {
        let ret = {};
        ret.textAlign = this.isRtl ? 'left' : 'right';
        ret.padding = '15px 0';

        return ret;
      },
    },

    methods: {
      initialize() {
        this.$delegate('edms', 'getContentAsPage', {
          key: 'contact-page'
        }).then((response) => {
          this.content = response.result;
        }).catch((err) => {
          this.$notify({
            title: 'Exception in page',
            message: err,
            type: 'error'
          });
        });
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('ok');
          } else {
            return false;
          }
        });
      },
    },


    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },
    beforeRouteUpdate(to, from, next) {
      this.initialize();
      next();
    }
  }
</script>

<style scoped>
    .contact-content {
    }

</style>